import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Progress } from './ui/progress';
import { Badge } from './ui/badge';
import { Lock, Calendar, AlertCircle } from 'lucide-react';
import EmbeddedModule from './EmbeddedModule';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DPDPReadiness = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/dpdp/readiness`)
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  return (
    <EmbeddedModule
      eyebrow="MeitY · DPDP Act 2026"
      title="DPDP Readiness 2026"
      tagline="Race the November 2026 enforcement deadline. Score your data-protection posture, close gaps and ship a Stage-3 ready operating model."
      badgeText="Nov 2026 Deadline"
      accentClass="from-emerald-700 via-emerald-600 to-teal-700"
      embedUrl="https://dpdp-shield.lovable.app"
      embedTitle="dpdp-shield.lovable.app"
      testId="dpdp-readiness-page"
      kpis={[
        { label: 'Days Left', value: data?.days_left ?? '—', hint: 'to 01-Nov-2026' },
        { label: 'Readiness Score', value: `${data?.score ?? 0}%` },
        { label: 'Open Actions', value: data?.open_actions ?? 0 },
        { label: 'Evidence Uploaded', value: data?.evidence_uploaded ?? 0 }
      ]}
    >
      <Card data-testid="dpdp-pillars">
        <CardHeader>
          <CardTitle className="flex items-center space-x-2">
            <Lock className="w-5 h-5 text-emerald-600" />
            <span>Compliance Pillars</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5">
            {data?.pillars.map((p, idx) => (
              <div key={idx} className="space-y-1.5">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-900">{p.name}</span>
                  <span className="text-xs font-mono text-gray-500">{p.score}%</span>
                </div>
                <Progress value={p.score} className="h-2" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </EmbeddedModule>
  );
};

export default DPDPReadiness;
